export default __webpack_public_path__ + "static/media/7osibs.784239aa.webp";